<template>
  <div :id="'mini_chart_'  + chartId" class="mini_chart">
    <div class="column" v-if="!chart">
      <p>
        <span id="animateLoading"></span>
        {{$t('msg.loading')}}...
      </p>
    </div>
    <div v-else class="column p10 flex_contant_center h_s">
      <canvas :id="'mainChartBlu'+chartId "></canvas>
    </div>
  </div>
</template>
<script>
import Chart from "chart.js";
import { mapGetters } from "vuex";

export default {
  props: ["coin"],
  created() {
    this.getHistoryDay();
  },
  mounted() {},
  data: () => ({
    chartId: (Math.random() * 5000).toFixed(),
    chart: false,
    chartDataOnChart: {
      labels: [],
      prices: []
    },
  }),
  components: {},
  methods: {
    async getHistoryDay() {
      let date = new Date();
      let endHour = this.sharedActions.formatDateTimeHistory(date);
      date.setDate(date.getDate() - 7);
      let startHour = this.sharedActions.formatDateTimeHistory(date);
      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: 60,
        sumbols: this.coin
      };
      let resp = await this.$store.dispatch("getCurrenciesHistory", params);
      this.filterChartData(resp.data[0]);
    },

    filterChartData(data) {
      let arrayPrices = [];
      let arrayDates = [];

      for (let i in data.history) {
        arrayPrices.push(data.history[i].close);
      }
      for (let i in data.history) {
        arrayDates.push(data.history[i].at);
      }

      this.chartDataOnChart.prices = arrayPrices;
      this.chartDataOnChart.labels = arrayDates;

      this.setUpChart();
    },

    setUpChart() {
      let chartData = {
        type: "line",
        data: {
          labels: this.chartDataOnChart.labels,
          datasets: [
            {
              label: "BLU (TUSD)",
              data: this.chartDataOnChart.prices,
              backgroundColor: ["#8a8bbe"],
              borderColor: ["#8a8bbe"],
              fill: false,
              borderWidth: 2,
              lineTension: 0
            }
          ],
          
        },
        
        options: {
          tooltips: {
            enabled: false,
          },

          legend: {
            display: false
          },

          elements: {
            display: false,
            point: {
              pointStyle: "none",
              radius: 0,
              hitRadius: 0
            }
          },

          scales: {
            xAxes: [
              {
                display: false,
              }
            ],
            yAxes: [
              {
                display: false,
                legend: false
              }
            ]
          }
        }
      };

      this.createChart("mainChartBlu" + this.chartId, chartData);
      this.chart = true;
    },
    createChart(chartId, chartData) {
      setTimeout(() => {
        const ctx = document.getElementById(chartId);
        const nasChart = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options
        });
      }, 100);
    }
  },
  computed: {},
  watch: {
    chartData: function() {
      if (this.chartData) {
        this.chart = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/public/charts_component/ChartLineMini.vue